import { QueryClient } from '@tanstack/react-query';
import { createAppQueryCache } from '@/services/query-error-handler';
import { handleQueryAuthRejection } from '@/services/auth';
import { shouldRetry } from '@/services/api/retry';

export function createAppQueryClient(): QueryClient {
  // The cache's auth-rejection handler needs the client to re-resolve auth, so
  // bind it to this instance. The callback only runs on a later fetch failure,
  // by which point `client` is assigned.
  const client: QueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // Retry 5xx/network (up to 3) but never 4xx: a 401/4xx won't succeed on
        // retry, and retrying it just delays the re-auth modal (which triggers
        // off the query's terminal error) and multiplies junk 401s. Individual
        // queries can still override.
        retry: shouldRetry,
      },
    },
    queryCache: createAppQueryCache((error, query) => handleQueryAuthRejection(error, query, client)),
  });
  return client;
}

export const queryClient = createAppQueryClient();
